import { clone, concat } from "ramda";
import { lazy, Suspense } from "react";
import { Outlet, ScrollRestoration, useLocation } from "react-router";
import { AuthGuard } from "@/components/auth/auth-guard";
import { LineLoading } from "@/components/loading";
import { useLatestMatch } from "@/hooks";
import { useSettings } from "@/store/settingStore";
import { cn } from "@/utils";
import { flattenTrees } from "@/utils/tree";
import { frontendNavData } from "./nav/nav-data/nav-data-frontend";

const Page403 = lazy(() => import("@/pages/error/Page403"));

/**
 * find auth by path
 * @param path
 * @returns
 */
function findAuthByPath(path: string): string[] {
  const foundItem = allItems.find((item) => item.path === path);
  return foundItem?.auth || [];
}

const navData = clone(frontendNavData);
const allItems = navData.reduce((acc: any[], group) => {
  const flattenedItems = flattenTrees(group.items);
  return concat(acc, flattenedItems);
}, []);

const Main = () => {
  const routeMatch = useLatestMatch();
  const fullWidth = (routeMatch?.handle as { fullWidth?: boolean })?.fullWidth ?? false;
  const { themeStretch } = useSettings();

  const { pathname } = useLocation();
  const currentNavAuth = findAuthByPath(pathname);

  return (
    <AuthGuard
      checkAny={currentNavAuth}
      fallback={
        <Suspense fallback={<LineLoading />}>
          <Page403 />
        </Suspense>
      }
    >
      <main
        data-slot="slash-layout-main"
        className={cn(
          "flex-auto w-full flex flex-col",
          "transition-[max-width] duration-300 ease-in-out",
          "px-4 py-2 mx-auto",
          {
            "max-w-full": themeStretch,
            "xl:max-w-screen-xl": !themeStretch && !fullWidth,
          },
        )}
        style={{
          willChange: "max-width",
        }}
      >
        <Suspense fallback={<LineLoading />}>
          <Outlet />
          <ScrollRestoration />
        </Suspense>
      </main>
    </AuthGuard>
  );
};

export default Main;
